<template>
  <div>
    <!-- 篩選條件區 -->
    <div class="content-8__controlbar">
      <div class="content-8__controlbar__item">
        <SMCheckBoxGroup
          v-model="selectFilterBalls"
          title="筛选球位"
          button-type="3"
          :filter-data="filterBalls"
        />
        <RadioButtons v-model="selectFilterProperty" title="筛选属性" :buttons="filterProperty" />
        <SMCheckBoxGroup
          ref="conditions"
          v-model="selectFilterConditions"
          title="筛选条件"
          button-type="2"
          :filter-data="filterConditions"
        />
      </div>
    </div>

    <div class="content-8__content">
      <div class="table-scroll">
        <table>
          <thead>
            <tr>
              <th rowspan="2">{{ isHK ? '日期/期数':'时间/期数' }} </th>
              <th rowspan="2">正码</th>
              <th rowspan="2">特码</th>
              <th
                rowspan="1"
                colspan="4"
              >总和</th>
              <th
                rowspan="1"
                colspan="5"
              >特码</th>
            </tr>
            <tr>
              <!-- 总和 -->
              <th>总数</th>
              <th>单双</th>
              <th>大小</th>
              <th>七色波</th>
              <th>单双</th>
              <!-- 特码 -->
              <th>大小</th>
              <th>合单双</th>
              <th>合大小</th>
              <th>尾大小</th>
            </tr>
          </thead>

          <tbody>
            <template v-for="(period, periodIndex) in tableData">
              <tr v-if="periodIndex < extendConut" :key="`${periodIndex}-tableData`">
                <!-- 期数 -->
                <td>
                  <div class="tableballbox">
                    <span v-if="isHK" class="textbox__text">
                      {{ formatDrawTime(period.drawTime) }} {{ period.period.substr(4) }}期
                    </span>
                    <span v-else class="textbox__text">
                      {{ formatDrawTime(period.drawTime) }} {{ period.period }}期
                    </span>
                  </div>
                </td>
                <!-- 正码 -->
                <td>
                  <div class="tableballbox">
                    <div v-for="(ball, ballIndex) in period.balls.slice(0,6)" :key="`${ballIndex}-ball`" class="tableballbox__item">
                      <div
                        class="ball circle size-middle"
                        :class="[getSebo(periodIndex,ballIndex),colorDisable(periodIndex,ballIndex)]"
                      >
                        <span class="ball__number">{{ padZero(ball) }}</span>
                      </div>
                      <div class="ballbox__item__detail">
                        <div class="detail-text">
                          {{ getName(periodIndex,ballIndex) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <!-- 特码 -->
                <td>
                  <div class="tableballbox">
                    <div class="tableballbox__item">
                      <div
                        class="ball circle size-middle"
                        :class="[getSebo(periodIndex,6),colorDisable(periodIndex,6)]"
                      >
                        <span class="ball__number">{{ padZero(period.balls[6]) }}</span>
                      </div>
                      <div class="ballbox__item__detail">
                        <div class="detail-text">
                          {{ getName(periodIndex,6) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <!-- 总数 -->
                <td>
                  <div class="tableballbox">
                    <span class="textbox__text">{{ period.zongHe[0] }}</span>
                  </div>
                </td>
                <!-- 单双 -->
                <td>
                  <div class="tableballbox">
                    <span class="textbox__text">{{ ruleCodeMapping[period.zongHeDanShuang[0]] }}</span>
                  </div>
                </td>
                <!-- 大小 -->
                <td>
                  <div class="tableballbox">
                    <span class="textbox__text">{{ ruleCodeMapping[period.zongHeDaXiao[0]] }}</span>
                  </div>
                </td>
                <!-- 七色波 -->
                <td>
                  <div class="tableballbox">
                    <span
                      class="textbox__text"
                      :class=" textColor(period.chiSeBo)"
                    >
                      {{ ruleCodeMapping[period.chiSeBo] }}
                    </span>
                  </div>
                </td>
                <!-- --------------特碼--------- -->
                <!-- 单双 -->
                <td>
                  <div class="tableballbox">
                    <span
                      class="textbox__text"
                      :class=" textColor(period.hmDanShuang[6])"
                    >
                      {{ ruleCodeMapping[period.hmDanShuang[6]] }}
                    </span>
                  </div>
                </td>
                <!-- 大小 -->
                <td>
                  <div class="tableballbox">
                    <span
                      class="textbox__text"
                      :class=" textColor(period.hmDaXiao[6])"
                    >
                      {{ ruleCodeMapping[period.hmDaXiao[6]] }}
                    </span>
                  </div>
                </td>
                <!-- 合单双 -->
                <td>
                  <div class="tableballbox">
                    <span
                      class="textbox__text"
                      :class=" textColor(period.hmHeDanShuang[6])"
                    >
                      合{{ ruleCodeMapping[period.hmHeDanShuang[6]] }}
                    </span>
                  </div>
                </td>
                <!-- 合大小 -->
                <td>
                  <div class="tableballbox">
                    <span
                      class="textbox__text"
                      :class=" textColor(period.hmHeDaXiao[6])"
                    >
                      合{{ ruleCodeMapping[period.hmHeDaXiao[6]] }}
                    </span>
                  </div>
                </td>
                <!-- 尾大小 -->
                <td>
                  <div class="tableballbox">
                    <span
                      class="textbox__text"
                      :class=" textColor(period.hmWeiShuDaXiao[6])"
                    >
                      尾{{ ruleCodeMapping[period.hmWeiShuDaXiao[6]] }}
                    </span>
                  </div>
                </td>
              </tr>
            </template>
            <tr v-if="!noMore">
              <td colspan="12">
                <span class="button-primary c8-datebox__item active" @click="loadList">显示更多</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { ruleCodeMapping } from '@/utils/newRuleCodeMapping-Sean'
import SMCheckBoxGroup from '@/components/desktop/common/SMCheckBoxGroup'
import RadioButtons from '@/components/desktop/common/RadioButtons'

export default {
  name: 'HaoMaZhuShou',
  components: {
    SMCheckBoxGroup,
    RadioButtons
  },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      extendConut: 30,
      ruleCodeMapping: { ...ruleCodeMapping },
      tab: 'number',
      selectFilterBalls: [],
      selectFilterProperty: 'shengXiao',
      selectFilterConditions: [],
      filterData: [
        { name: '2019年', val: '2019' },
        { name: '2020年', val: '2020' }
      ],
      filterBalls: [
        { name: '正码一', val: 0 },
        { name: '正码二', val: 1 },
        { name: '正码三', val: 2 },
        { name: '正码四', val: 3 },
        { name: '正码五', val: 4 },
        { name: '正码六', val: 5 },
        { name: '特码', val: 6 }
      ],
      filterProperty: [
        { name: '生肖', val: 'shengXiao' },
        { name: '五行', val: 'wuXing' },
        { name: '家禽野兽', val: 'shengXiaoDongWu' },
        { name: '男女生肖', val: 'shengXiaoNanNyu' },
        { name: '天地生肖', val: 'shengXiaoTianDi' },
        { name: '四季生肖', val: 'shengXiaoSihJi' },
        { name: '琴棋书画', val: 'shengXiaoSihYi' },
        { name: '三色生肖', val: 'shengXiaoYanSe' }
      ]
    }
  },
  computed: {
    noMore() {
      return this.extendConut >= this.tableData.length
    },
    isHK() {
      return this.$route.params.lottery_code === 'hk6'
    },
    // 根據選擇的屬性展示對應的篩選條件
    filterConditions() {
      switch (this.selectFilterProperty) {
        case 'shengXiao':
          return [
            { name: '鼠', val: 'shengXiao_shu' },
            { name: '牛', val: 'shengXiao_niou' },
            { name: '虎', val: 'shengXiao_hu' },
            { name: '兔', val: 'shengXiao_tu' },
            { name: '龙', val: 'shengXiao_long' },
            { name: '蛇', val: 'shengXiao_she' },
            { name: '马', val: 'shengXiao_ma' },
            { name: '羊', val: 'shengXiao_yang' },
            { name: '猴', val: 'shengXiao_hou' },
            { name: '鸡', val: 'shengXiao_ji' },
            { name: '狗', val: 'shengXiao_gou' },
            { name: '猪', val: 'shengXiao_jhu' }
          ]
        case 'wuXing':
          return [
            { name: '金', val: 'wuXing_jin' },
            { name: '木', val: 'wuXing_mu' },
            { name: '水', val: 'wuXing_shuei' },
            { name: '火', val: 'wuXing_huo' },
            { name: '土', val: 'wuXing_tu' }
          ]
        case 'shengXiaoDongWu':
          return [
            { name: '家禽', val: 'dongWu_jiaChin' },
            { name: '野兽', val: 'dongWu_yehShou' }
          ]
        case 'shengXiaoNanNyu':
          return [
            { name: '男肖', val: 'nanNyu_nan' },
            { name: '女肖', val: 'nanNyu_nyu' }
          ]
        case 'shengXiaoTianDi':
          return [
            { name: '天肖', val: 'tianDi_tian' },
            { name: '地肖', val: 'tianDi_di' }
          ]
        case 'shengXiaoSihJi':
          return [
            { name: '春肖', val: 'sihJi_chun' },
            { name: '夏肖', val: 'sihJi_sia' },
            { name: '秋肖', val: 'sihJi_chiou' },
            { name: '冬肖', val: 'sihJi_dong' }
          ]
        case 'shengXiaoSihYi':
          return [
            { name: '琴肖', val: 'sihYi_chin' },
            { name: '棋肖', val: 'sihYi_chi' },
            { name: '书肖', val: 'sihYi_shu' },
            { name: '画肖', val: 'sihYi_hua' }
          ]
        case 'shengXiaoYanSe':
          return [
            { name: '红肖', val: 'yanse_hong' },
            { name: '蓝肖', val: 'yanse_lan' },
            { name: '绿肖', val: 'yanse_lyu' }
          ]
        default:
          console.warn('匹配不到 filterConditions 請檢查 filterProperty')
          return []
      }
    }
  },
  watch: {
    selectFilterProperty() {
      this.$refs.conditions.clearAll()
      this.selectFilterConditions = []
    }
  },
  methods: {
    // 拿顏色
    getSebo(periodIndex, ballIndex) {
      switch (this.tableData[periodIndex].seBo[ballIndex]) {
        case 'yanse_hong':
          return 'color--red'
        case 'yanse_lan':
          return 'color--blue'
        case 'yanse_lyu':
          return 'color--green'
        default:
          return ''
      }
    },
    // 過濾球
    colorDisable(periodIndex, ballIndex) {
      if (this.selectFilterBalls.length !== 0) {
        if (
          !this.selectFilterBalls.includes(ballIndex)
        ) { return 'color-disable' }
      }
      if (this.selectFilterConditions.length !== 0) {
        if (
          !this.selectFilterConditions.includes(this.tableData[periodIndex][this.selectFilterProperty][ballIndex])
        ) { return 'color-disable' }
      }
      return ''
    },
    // 拿名字
    getName(periodIndex, ballIndex) {
      switch (this.selectFilterProperty) {
        case 'shengXiao':
          return ruleCodeMapping[this.tableData[periodIndex].shengXiao[ballIndex]]
        case 'wuXing':
          return ruleCodeMapping[this.tableData[periodIndex].wuXing[ballIndex]]
        case 'shengXiaoDongWu':
          return ruleCodeMapping[this.tableData[periodIndex].shengXiaoDongWu[ballIndex]]
        case 'shengXiaoNanNyu':
          return ruleCodeMapping[this.tableData[periodIndex].shengXiaoNanNyu[ballIndex]]
        case 'shengXiaoTianDi':
          return ruleCodeMapping[this.tableData[periodIndex].shengXiaoTianDi[ballIndex]]
        case 'shengXiaoSihJi':
          return ruleCodeMapping[this.tableData[periodIndex].shengXiaoSihJi[ballIndex]]
        case 'shengXiaoSihYi':
          return ruleCodeMapping[this.tableData[periodIndex].shengXiaoSihYi[ballIndex]]
        case 'shengXiaoYanSe':
          return ruleCodeMapping[this.tableData[periodIndex].shengXiaoYanSe[ballIndex]]
        default:
          return ruleCodeMapping[this.tableData[periodIndex].shengXiao[ballIndex]]
      }
    },
    changeTab(type) {
      this.tab = type
    },
    selectTab(currentTab) {
      return this.tab === currentTab ? 'td td--active' : 'td'
    },
    textColor(value) {
      switch (value) {
        case 'daxiao_da':
        case 'danshuang_shuang':
        case 'yanse_hong':
          return 'red'
        case 'yanse_lan':
        case 'daxiao_he':
        case 'danshuang_he':
          return 'blue'
        case 'yanse_lyu':
          return 'green'
        default:
          return ''
      }
    },
    // 轉換utc時間格式
    formatDrawTime(time) {
      return this.isHK ? moment(time).format('YYYY/MM/DD') : moment(time).format('HH:mm')
    },
    // 一次性載入的數量
    loadList() {
      this.extendConut += 30
    },
    padZero(num) {
      return String(num).padStart(2, '0')
    }
  }
}
</script>

<style lang="scss" scoped>
  .c8-datebox__item {
    &:hover {
      cursor: pointer;
    }
  }
</style>
